import { breakpoints } from '@pocketlaw/tetris';
import { createGlobalStyle } from 'styled-components';
/* eslint-disable pocketlaw/no-px-units */
/**
 * Why do we have this?
 */
export const GlobalCSS = createGlobalStyle `
  ${breakpoints.mobile} {
    input, textarea {
    font-size: 16px!important;
    }
  }
`;
